var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1306.72 1306.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{mix-blend-mode:multiply;}.cls-3{fill:#fff;}.cls-4{fill:#1a1a1a;}.cls-5{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 198.64,
    y1: 198.64,
    x2: 1116.83,
    y2: 1116.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a18e77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e7d69"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 654.69,
    cy: 654.69,
    r: 616.36
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 653.36,
    cy: 653.36,
    r: 583.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 639.17,
    y: 101.2,
    width: 28.37,
    height: 35.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 691.27,
    y: 119.12,
    width: 35.86,
    height: 5.87,
    transform: "translate(513.69 814.61) rotate(-84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 746.5,
    y: 127.87,
    width: 35.86,
    height: 5.87,
    transform: "translate(477.54 851.33) rotate(-78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 800.51,
    y: 142.34,
    width: 35.86,
    height: 5.87,
    transform: "translate(427.4 878.79) rotate(-72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 852.72,
    y: 162.38,
    width: 35.86,
    height: 5.87,
    transform: "translate(365.49 893.44) rotate(-66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 902.54,
    y: 176.52,
    width: 35.86,
    height: 28.37,
    transform: "translate(295.08 892.5) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 949.44,
    y: 218.22,
    width: 35.86,
    height: 5.87,
    transform: "translate(219.86 873.81) rotate(-54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 992.89,
    y: 253.41,
    width: 35.86,
    height: 5.87,
    transform: "translate(143.91 835.95) rotate(-48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1032.43,
    y: 292.95,
    width: 35.86,
    height: 5.87,
    transform: "translate(71.79 778.81) rotate(-42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1067.63,
    y: 336.41,
    width: 35.86,
    height: 5.87,
    transform: "translate(7.84 702.82) rotate(-36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1098.08,
    y: 372.06,
    width: 35.86,
    height: 28.37,
    transform: "translate(-43.6 609.76) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1123.47,
    y: 433.13,
    width: 35.86,
    height: 5.87,
    transform: "translate(-78.69 501.95) rotate(-24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1143.51,
    y: 485.34,
    width: 35.86,
    height: 5.87,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -94.05, 382.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1157.98,
    y: 539.35,
    width: 35.86,
    height: 5.87,
    transform: "translate(-87.06 256.38) rotate(-12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1166.73,
    y: 594.58,
    width: 35.86,
    height: 5.87,
    transform: "translate(-56.02 127.24) rotate(-6.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1169.65,
    y: 639.17,
    width: 35.86,
    height: 28.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1181.73,
    y: 691.27,
    width: 5.87,
    height: 35.86,
    transform: "translate(355.52 1813.24) rotate(-84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1172.98,
    y: 746.5,
    width: 5.87,
    height: 35.86,
    transform: "translate(183.69 1755.7) rotate(-78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1158.5,
    y: 800.51,
    width: 5.87,
    height: 35.86,
    transform: "translate(24.14 1670.12) rotate(-72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1138.47,
    y: 852.72,
    width: 5.87,
    height: 35.86,
    transform: "translate(-118.23 1559.23) rotate(-66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1101.83,
    y: 902.54,
    width: 28.37,
    height: 35.86,
    transform: "translate(-239.15 1426.71) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1082.62,
    y: 949.44,
    width: 5.87,
    height: 35.86,
    transform: "translate(-335.14 1276.99) rotate(-54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1047.43,
    y: 992.89,
    width: 5.87,
    height: 35.86,
    transform: "translate(-403.66 1115.03) rotate(-48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1007.89,
    y: 1032.43,
    width: 5.87,
    height: 35.86,
    transform: "translate(-443.2 946.16) rotate(-42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 964.43,
    y: 1067.63,
    width: 5.87,
    height: 35.86,
    transform: "translate(-453.32 775.93) rotate(-36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 906.29,
    y: 1098.08,
    width: 28.37,
    height: 35.86,
    transform: "translate(-434.69 609.77) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 867.71,
    y: 1123.47,
    width: 5.87,
    height: 35.86,
    transform: "translate(-388.99 452.82) rotate(-24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 815.51,
    y: 1143.51,
    width: 5.87,
    height: 35.86,
    transform: "translate(-318.85 309.76) rotate(-18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 761.49,
    y: 1157.98,
    width: 5.87,
    height: 35.86,
    transform: "translate(-227.79 184.63) rotate(-12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 706.27,
    y: 1166.73,
    width: 5.87,
    height: 35.86,
    transform: "translate(-119.94 80.62) rotate(-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 639.17,
    y: 1169.65,
    width: 28.37,
    height: 35.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 579.58,
    y: 1181.72,
    width: 35.86,
    height: 5.87,
    transform: "translate(-643.16 1654.93) rotate(-83.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 524.35,
    y: 1172.98,
    width: 35.86,
    height: 5.87,
    transform: "translate(-720.69 1461.81) rotate(-78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 470.34,
    y: 1158.5,
    width: 35.86,
    height: 5.87,
    transform: "translate(-767.22 1266.79) rotate(-71.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 418.14,
    y: 1138.47,
    width: 35.86,
    height: 5.87,
    transform: "translate(-784.02 1075.52) rotate(-66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 368.31,
    y: 1101.83,
    width: 35.86,
    height: 28.37,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -773.37, 892.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 321.41,
    y: 1082.62,
    width: 35.86,
    height: 5.87,
    transform: "translate(-738.37 722.07) rotate(-54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 277.96,
    y: 1047.43,
    width: 35.86,
    height: 5.87,
    transform: "translate(-682.68 567.44) rotate(-48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.42,
    y: 1007.89,
    width: 35.86,
    height: 5.87,
    transform: "translate(-610.57 431.23) rotate(-42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 203.23,
    y: 964.43,
    width: 35.86,
    height: 5.87,
    transform: "translate(-526.36 314.73) rotate(-36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 172.77,
    y: 906.29,
    width: 35.86,
    height: 28.37,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -434.69, 218.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 147.38,
    y: 867.71,
    width: 35.86,
    height: 5.87,
    transform: "translate(-339.83 142.51) rotate(-24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 127.34,
    y: 815.51,
    width: 35.86,
    height: 5.87,
    transform: "translate(-245.77 84.94) rotate(-18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 112.87,
    y: 761.49,
    width: 35.86,
    height: 5.87,
    transform: "translate(-156.09 43.9) rotate(-12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.12,
    y: 706.27,
    width: 35.86,
    height: 5.87,
    transform: "translate(-73.46 16.64) rotate(-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 101.2,
    y: 639.17,
    width: 35.86,
    height: 28.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 119.12,
    y: 579.58,
    width: 5.87,
    height: 35.86,
    transform: "translate(-484.95 656.44) rotate(-84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 127.87,
    y: 524.35,
    width: 5.87,
    height: 35.86,
    transform: "translate(-426.83 557.48) rotate(-78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 142.34,
    y: 470.34,
    width: 5.87,
    height: 35.86,
    transform: "translate(-363.99 475.55) rotate(-72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 162.38,
    y: 418.14,
    width: 5.87,
    height: 35.86,
    transform: "translate(-300.29 409.73) rotate(-66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 176.52,
    y: 368.31,
    width: 28.37,
    height: 35.86,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -239.15, 358.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 218.22,
    y: 321.41,
    width: 5.87,
    height: 35.86,
    transform: "translate(-183.37 318.81) rotate(-54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 253.41,
    y: 277.96,
    width: 5.87,
    height: 35.86,
    transform: "translate(-135.07 288.4) rotate(-48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 292.95,
    y: 238.42,
    width: 5.87,
    height: 35.86,
    transform: "translate(-95.53 263.83) rotate(-42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 336.41,
    y: 203.23,
    width: 5.87,
    height: 35.86,
    transform: "matrix(0.81, -0.59, 0.59, 0.81, -65.18, 241.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 372.06,
    y: 172.77,
    width: 28.37,
    height: 35.86,
    transform: "translate(-43.6 218.67) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 433.13,
    y: 147.38,
    width: 5.87,
    height: 35.86,
    transform: "translate(-29.54 191.65) rotate(-24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 485.34,
    y: 127.34,
    width: 5.87,
    height: 35.86,
    transform: "translate(-20.99 158) rotate(-18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 539.35,
    y: 112.87,
    width: 5.87,
    height: 35.86,
    transform: "translate(-15.35 115.6) rotate(-12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 594.58,
    y: 104.12,
    width: 5.87,
    height: 35.86,
    transform: "translate(-9.49 63.13) rotate(-6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1071.47,626.71l6.71-9.17a26.31,26.31,0,0,1,19.59-8.5c14.11,0,22.33,7.81,22.33,18.5a12.27,12.27,0,0,1-4.38,9.17c-2.47,2.2-5.48,4.11-10.14,7V644C1119,646.3,1126,655.34,1126,665.62c-.14,22.33-29.86,32-38.36,32-7,0-12.6-2.33-15.34-4.52-2.19-1.78-3.15-3.7-3.15-5.48,0-2.6,2.19-4.93,4-6.3a4,4,0,0,1,5.21-.14c3,2.61,9.45,8.77,17.53,8.77,7,0,12.33-5.62,12.33-18.49,0-13.15-9-17.81-16.44-17.81a31,31,0,0,0-7.39,1l-1-4.66c11.5-3.83,19.72-9.31,19.72-17.81,0-8.9-5.61-12.46-11.78-12.46-6.85,0-11.64,3.83-16.3,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M242,643.49c0,24.8-14.52,42.2-33.84,49.87-5.48,2.19-17.26,4.38-23.42,4.52l-.82-4.94c20.27-3.56,34.38-18.21,37.8-34.65l-6.57,3.42c-3.29,1.78-5.62,2.47-8,2.47-16.3,0-26.43-11.51-26.43-25.89,0-12.19,10.41-29.45,31.23-29.45C232,608.84,242,624.73,242,643.49Zm-43.15-10.68c0,11.64,6.3,21.92,16.3,21.92a17.41,17.41,0,0,0,7.53-1.78,69.74,69.74,0,0,0,.69-10.14c0-13.42-3.43-28.49-14-28.49C202,614.32,198.81,624,198.81,632.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1037.77,898.8v8.63c0,8.22,1,9.59,11.1,10.55v4.66h-40.82V918c11.64-1,12.33-2.88,12.33-11.23v-8h-34.8v-5.61c14.8-21,29.32-40.69,42.33-56.72h9.86V891h12.33v7.81Zm-17.39-43.7h-.28c-6.57,9-15.34,21.65-24.24,35.89h24.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1062.63,448.73c-2.19,7.95-3.83,16.58-5.34,22.33h-54.93V467.5c7.26-7.12,15.21-14.66,21.92-22.6,9.59-11.37,15.07-21.64,15.07-32.06,0-9.45-4.94-16.3-14.39-16.3-8.22,0-13.83,5.76-18.35,12.2l-4-3.29,8.77-12.88a28.92,28.92,0,0,1,20.69-8.49c13.56,0,24.93,9.18,24.93,24.38,0,10.82-5.62,19.32-19.18,32.19l-16.44,15.62h22.33c8.22,0,9.31-.28,14.38-9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.19,856.27a13.56,13.56,0,0,1-4.52,10.13,72.65,72.65,0,0,1-10,7.54c9.59,5.2,18.22,11.64,18.22,23.7,0,17.39-17.26,26-30.55,26-17.94,0-29.72-9.17-29.72-23.15,0-6.43,3.28-9.72,5.75-12s8.63-6,12.74-8.36C267.16,875.72,260,869,260,858.87c0-13,11.51-23.83,27.94-23.83C303.05,835,313.19,844.08,313.19,856.27Zm-12.88,47c-.27-9.86-6.85-13.42-20.13-20.54-4,3-7.13,9-7.13,16.16,0,13.29,7.95,19.31,14.52,19.31C295.38,918.18,300.45,912.29,300.31,903.25Zm-24.52-50.68c0,9.32,7.13,13.83,17.67,18.77,2.33-2.2,5.07-6.44,5.07-14.39,0-11.78-7-16.43-12.46-16.43C279.49,840.52,275.79,846.82,275.79,852.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M245.18,470v-4.65c10.82-.69,12.05-2.74,12.05-12.47V403.19c0-7.13-.55-8.08-6.16-8.5l-7-.54v-4c9-1.37,19.18-3.83,31.23-7.12v69.86c0,9.45,1,11.78,11.92,12.47V470Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M358.73,427.3c0,20-7.26,44.38-30.27,44.38s-30.41-24.52-30.41-44.25c0-20.27,7.81-44.38,30.41-44.38C351.47,383.05,358.73,407.43,358.73,427.3Zm-41.91-.41c0,18.49,2.87,39.17,11.91,39.17s11.37-20,11.37-39c0-19.31-2.87-38.35-11.78-38.35C319,388.67,316.82,408.53,316.82,426.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M858.92,1020.39c6.71-2.6,14.1-4.52,17.67-4.52,17.53,0,27.39,11.23,27.39,23,0,8.49-4.24,16.58-13.83,23.29-7.67,5.61-17.4,9.18-25.62,9.31-5.48,0-11.23-1.92-14.24-4.38-2.74-2.19-3.29-3.56-3.29-5.62s1.92-5.2,4.38-7c1.64-1.1,3.15-.69,4.93.82,3.29,3,9.86,8.35,17.67,8.35,8.5,0,12.6-7.53,12.6-17.67,0-12.19-7.8-20.27-20.27-20.27a49,49,0,0,0-14.93,2.6l6.16-43.83H901l.82,1.37-4.38,13.42h-34.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M869.74,322.22v-4.66c10.82-.69,12-2.74,12-12.47V255.37c0-7.12-.55-8.08-6.16-8.49l-7-.55v-4c9-1.37,19.18-3.84,31.23-7.13v69.86c0,9.46,1,11.78,11.92,12.47v4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M463.83,986.14c-13,27.54-26.85,55.62-39.32,83.7l-14.11,1.64-1.09-1.78A759.6,759.6,0,0,0,451,999.29H421.77c-9.31,0-10.41,1-14.24,9h-4.8c1.92-10.68,2.74-17.94,3.7-23.83h56.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M396,322.22v-4.66c10.82-.69,12.06-2.74,12.06-12.47V255.37c0-7.12-.55-8.08-6.17-8.49l-7-.55v-4c9-1.37,19.17-3.84,31.23-7.13v69.86c0,9.45,1,11.78,11.91,12.47v4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M459,322.22v-4.66c10.82-.69,12.06-2.74,12.06-12.47V255.37c0-7.12-.55-8.08-6.17-8.49l-7-.55v-4c9-1.37,19.17-3.84,31.23-7.13v69.86c0,9.45,1,11.78,11.91,12.47v4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M649.93,1078.45c3.43-1.51,5.89-2.61,8.08-2.61,15.76,0,26.31,10.14,26.31,25.62,0,17.26-13.15,31.09-31.24,31.09-17.12,0-30.68-13.15-30.68-34.93,0-29.17,20.55-44.79,36.44-50.13,6-2.06,15.2-3.7,20.41-4.39l1,5.21a68,68,0,0,0-14.66,4.93,42,42,0,0,0-22.47,28.49Zm-7.8,8.63a64.6,64.6,0,0,0-.83,11c0,18.22,7.4,28.91,14.66,28.91,8.36-.14,10.41-10.69,10.41-19.45,0-12.88-6.44-21.92-15.61-21.92A24.72,24.72,0,0,0,642.13,1087.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M597,261.14v-4.65c10.82-.69,12.06-2.74,12.06-12.47V194.3c0-7.13-.55-8.08-6.17-8.5l-7-.54v-4c9.05-1.37,19.18-3.83,31.24-7.12V244c0,9.45,1,11.78,11.91,12.47v4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M710.82,238.82c-2.19,7.94-3.84,16.57-5.34,22.32H650.55v-3.56c7.26-7.12,15.2-14.65,21.92-22.6,9.58-11.37,15.06-21.64,15.06-32,0-9.45-4.93-16.3-14.38-16.3-8.22,0-13.84,5.75-18.36,12.19l-4-3.29,8.77-12.88a28.92,28.92,0,0,1,20.68-8.49c13.56,0,24.93,9.18,24.93,24.38,0,10.83-5.61,19.32-19.17,32.19l-16.44,15.62h22.33c8.22,0,9.31-.27,14.38-9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M653.36,69.74c149.36,0,298.72,57,412.67,170.94C1294,468.6,1294,838.12,1066,1066,952.08,1180,802.72,1237,653.36,1237S354.64,1180,240.68,1066c-227.91-227.91-227.91-597.43,0-825.35,114-114,263.32-170.94,412.68-170.94m0-69.74A653.93,653.93,0,0,0,407.53,47.85,650.72,650.72,0,0,0,293.8,107.69,659.06,659.06,0,0,0,107.69,293.8a653.22,653.22,0,0,0,0,719.11A659.06,659.06,0,0,0,293.8,1199a650.1,650.1,0,0,0,234.83,95.74,655.08,655.08,0,0,0,370.55-35.89A650.41,650.41,0,0,0,1012.91,1199,659.06,659.06,0,0,0,1199,1012.91a650.1,650.1,0,0,0,95.74-234.83,655.08,655.08,0,0,0-35.89-370.55A650.77,650.77,0,0,0,1199,293.8a659.06,659.06,0,0,0-186.11-186.11A650.57,650.57,0,0,0,778.08,12,657.87,657.87,0,0,0,653.36,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2cca281c5554d81089d097eac41312f0.svg";
export { ForwardRef as ReactComponent };